<template>
  <div class="soraban-switch">
    <span
      class="switch-status-inactive__text"
      :class="{ 'switch-status-inactive__text--active': !checkedInternal }"
    >
      {{ offText }}
    </span>
    <v-switch
      class="v-switch py-0 my-0"
      v-model="checkedInternal"
      :label="label"
      :readonly="readonly"
      @change="$emit('change', checkedInternal ? trueValue : falseValue)"
      @focus="$emit('focus')"
      @blur="$emit('focus')"
      hide-details
    />
    <span
      class="switch-status-active__text"
      :class="{
        'primary--text switch-status-active__text--active': checkedInternal,
      }"
    >
      {{ onText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SorabanSwitch',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: [Boolean, String],
    label: {
      required: false,
      default: '',
      type: String,
    },
    offText: {
      required: false,
      default: '',
      type: String,
    },
    onText: {
      required: false,
      default: '',
      type: String,
    },
    trueValue: {
      required: false,
      default: true,
      type: [String, Boolean],
    },
    falseValue: {
      required: false,
      default: false,
      type: [String, Boolean],
    },
    readonly: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      checkedInternal: this.checked === this.trueValue,
    };
  },
  watch: {
    checked() {
      this.checkedInternal = this.checked === this.trueValue;
    },
  },
};
</script>

<style lang="postcss" scoped>
.soraban-switch {
  display: flex;
  align-items: center;
  flex-grow: 0 !important;
}

.v-switch {
  flex-grow: 0;
  margin-left: 4px !important;
  margin-right: 6px !important;
  margin-bottom: 2px !important;

  & >>> .v-input--switch__track {
    color: var(--color-grey--light);
  }

  & >>> .v-input--switch__thumb {
    color: white !important;
    opacity: 0.8;
  }

  & >>> .v-input--selection-controls__input {
    margin-right: 0;
  }

  & >>> .v-input--switch__track {
    height: 18px;
    width: 37px;
    opacity: 1;
    border-radius: 9px;
  }

  & >>> .v-input--switch__thumb {
    width: 14px;
    height: 14px;
    top: 7px;
    left: 5px;
  }

  & >>> label {
    padding-top: 3px;
    padding-left: 6px;
  }
}

.switch-status-inactive__text {
  color: var(--color-grey--dark);
  font-weight: 300;
  font-style: italic;
  &--active {
    font-weight: 800;
    font-style: normal;
  }
}

>>> .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,
>>> .v-input--switch.v-input--is-dirty .v-input--switch__thumb {
  transform: translate(18px, 0) !important;
}
</style>
